import {
  CaseReducer,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { api } from "../api";
import { ProposalsInitialState } from "../types/ProposalTypes";

export const fetchProposalSettings = createAsyncThunk<
  Omit<ProposalsInitialState, "loading">,
  string | undefined
>(
  "requests",
  /** @param {string | undefined} id_proposal */
  async (id_proposal: string | undefined, thunkAPI) => {
    try {
      const responseProposalSettings = await thunkAPI.dispatch(
        api.fetchProposalData.initiate(id_proposal),
      );

      if (responseProposalSettings.isError) {
        const error = responseProposalSettings.error as any;
        throw new Error(error.data.errors.message);
      }

      return {
        proposalSettings: responseProposalSettings.data,
      } as Omit<ProposalsInitialState, "loading">;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const fetchRegularProposalData = createAsyncThunk<
  Omit<ProposalsInitialState, "loading">,
  string | undefined
>(
  "requests/fetchRegularProposalData",
  /** @param {string | undefined} id_proposal */
  async (id_proposal: string | undefined, thunkAPI) => {
    try {
      const responseProposalSettings = await thunkAPI.dispatch(
        api.fetchRegularProposalData.initiate(id_proposal),
      );
      if (responseProposalSettings.isError) {
        const error = responseProposalSettings.error as any;
        throw new Error(error.data.errors.message);
      }
      return {
        proposalSettings: responseProposalSettings.data,
      } as Omit<ProposalsInitialState, "loading">;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const signStatusReducer: CaseReducer<
  ProposalsInitialState,
  PayloadAction<string>
> = (state, action) => {
  state.proposalSettings.proposal.sign_status = action.payload;

  return state;
};

const setPaymentLinkReducer: CaseReducer<
  ProposalsInitialState,
  PayloadAction<string | string[] | boolean | undefined>
> = (state, action) => {
  state.paymentLink = action.payload;

  return state;
};

const proposals = createSlice({
  name: "proposal",
  initialState: {
    proposalSettings: {},
    paymentLink: undefined,
    loading: false as boolean,
  } as ProposalsInitialState,
  reducers: {
    setSignStatus: signStatusReducer,
    setPaymentLink: setPaymentLinkReducer,
  },
  extraReducers(builder) {
    builder.addCase(fetchProposalSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProposalSettings.fulfilled, (state, action) => {
      state.proposalSettings = action.payload.proposalSettings;
      state.loading = false;
    });
    builder.addCase(fetchProposalSettings.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(fetchRegularProposalData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRegularProposalData.fulfilled, (state, action) => {
      state.proposalSettings = action.payload.proposalSettings;
      state.loading = false;
    });
    builder.addCase(fetchRegularProposalData.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { setSignStatus, setPaymentLink } = proposals.actions;
export default proposals.reducer;
